import { render, staticRenderFns } from "./Staging-New-Request-Step4.vue?vue&type=template&id=78935d4d&scoped=true&"
import script from "./Staging-New-Request-Step4.vue?vue&type=script&lang=js&"
export * from "./Staging-New-Request-Step4.vue?vue&type=script&lang=js&"
import style0 from "./Staging-New-Request-Step4.vue?vue&type=style&index=0&id=78935d4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78935d4d",
  null
  
)

export default component.exports